import type { Category } from './types';
import { SelectField, SelectFieldProps } from '@ff-it/form';
import useSWR from 'swr';
import { ReactElement } from 'react';

const categoryFieldProps = {
  getOptionLabel: ({ name }: Category) => name,
  getOptionValue: (a: Category) => a.id.toString(),
};

export function useCategories(): Category[] {
  const { data: options } = useSWR<Category[]>({
    method: 'GET',
    url: 'supplier/categories/',
  });
  return options || [];
}

type CategoryFieldProps = Omit<SelectFieldProps<Category, any, any>, 'options' | 'loadOptions' | 'defaultOptions'>;

// IMPORTANT: This is not constant list, but is practice it's short and stable. We also filter kind on client
export function CategoryField(props: CategoryFieldProps): ReactElement {
  const options = useCategories();

  return <SelectField options={options} {...categoryFieldProps} {...props} />;
}
